var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 10c0 0 0 0.1 0 0.1l0 40c0 5.5 4.5 10 10 10l53.1 0c5.5 0 10-4.5 10-10l0-40.1c0-5.5-4.5-9.9-10-9.9l-53.1 0c-5.5 0-9.9 4.5-10 10Zm7-1.4c0.5-1.1 1.7-1.8 3-1.8l53.1 0c1.3 0 2.4 0.8 3 1.8l-29.5 20.8 -29.5-20.8Zm59.4 7.9l0 33.6c0 1.8-1.5 3.3-3.3 3.3l-53.1 0c-1.8 0-3.3-1.5-3.3-3.3l0-33.6 28 19.7c1.1 0.8 2.7 0.8 3.8 0l28-19.7Z"}));
}

Envelope.defaultProps = {"width":"73","height":"60","viewBox":"0 0 73 60","strokeLinejoin":"round"};

module.exports = Envelope;

Envelope.default = Envelope;
